import Auction from '../components/Auction'
import { connect } from 'react-redux';
import {nextAuction, previousAuction, resetAuction, showAuction} from "../actions";

function mapStateToProps(state, ownProps) {
    return {
        pbnDealer: state.pbnData.pbnDealer,
        auctionArray: state.pbnData.auction.auctionArray,
        auctionProgressPointer: state.pbnData.auctionProgressPointer
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        onAuctionPreviousClick: function() {
            dispatch(previousAuction());
        },
        onAuctionNextClick: function() {
            dispatch(nextAuction());
        },
        onAuctionShowClick: function() {
            dispatch(showAuction());
        },
        onAuctionHideClick: function() {
            dispatch(resetAuction());
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Auction)